import React from "react";
import { Loader } from "@campgladiator/cgui-core.atoms.loader";
import { Note } from "./components/Note";
import { NoteDTO } from "@campgladiator/cg-common.types.types";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import styles from "./NoteManagement.module.scss";
import { Button, ButtonProps } from "@campgladiator/cgui-core.atoms.button";

export type NoteManagementProps = {
  adminId: string;
  buttonProps: ButtonProps;
  clearErrors: () => void;
  error: string;
  handleCancelAddNewNote: (id: string) => Promise<boolean>;
  handleDeleteNote: (id: string) => Promise<boolean>;
  handleEditNote: (id: string, note: string) => Promise<boolean>;
  handleSaveNewNote: (id: string, note: string) => Promise<boolean>;
  hasMoreNotes: boolean;
  htmlDivAttributes?: React.HTMLAttributes<HTMLDivElement>;
  isFirstLoad: boolean;
  isLoading: boolean;
  notes: NoteDTO[];
  successMessage?: string;
};

const NoteManagement = (props: NoteManagementProps) => {
  const {
    adminId,
    buttonProps,
    hasMoreNotes,
    isFirstLoad,
    isLoading,
    notes,
    handleCancelAddNewNote,
    handleDeleteNote,
    handleEditNote,
    handleSaveNewNote,
    htmlDivAttributes,
  } = props;

  return (
    <div {...htmlDivAttributes}>
      {isFirstLoad && isLoading ? (
        <div className={styles.emptyNote}>
          <Loader />
        </div>
      ) : !isLoading && !notes.length ? (
        <Paragraph className={styles.emptyNote}>
          There are no notes on this account currently.
        </Paragraph>
      ) : (
        <>
          {notes.map(({ id, created, createdBy, note: content }) => (
            <Note
              key={id}
              adminId={adminId}
              createdBy={createdBy}
              timestampDate={created}
              note={content}
              noteId={id}
              handleCancelAddNewNote={handleCancelAddNewNote}
              handleDeleteNote={handleDeleteNote}
              handleEditNote={handleEditNote}
              handleSaveNewNote={handleSaveNewNote}
            />
          ))}

          {hasMoreNotes && (
            <div className={styles.buttonWrapper}>
              <Button {...buttonProps}>{buttonProps.children}</Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NoteManagement;
